import cx from 'classnames'

import MenuItem, { ItemType } from './menu-item'

interface MenuProps {
  items: ItemType[]
  hasFocus?: boolean
  useMegaNav?: boolean
  onClick?: () => void
  className?: string
  isFooterMenu?: boolean
  isHeaderDesktopMenu?: boolean
  isHeaderMobilePrimaryMenu?: boolean
  isHeaderMobileSecondaryMenu?: boolean
  isMegaNavMenu?: boolean
}

const Menu = ({
  items,
  hasFocus = true,
  useMegaNav = false,
  onClick,
  isFooterMenu,
  isHeaderDesktopMenu,
  isHeaderMobilePrimaryMenu,
  isHeaderMobileSecondaryMenu,
  isMegaNavMenu,
  className,
}: MenuProps) => {
  return (
    <ul
      className={cx(
        {
          'flex flex-col lg:mb-8 px-0': isFooterMenu,
          'flex flex-wrap': isHeaderDesktopMenu,
          'flex flex-col':
            isHeaderMobilePrimaryMenu || isHeaderMobileSecondaryMenu,
        },
        className
      )}
    >
      {items.map((item) => {
        return (
          <li
            key={item._key}
            className={cx({
              'mb-2': isFooterMenu || isMegaNavMenu,
              'mb-3': isHeaderMobilePrimaryMenu || isHeaderMobileSecondaryMenu,
              'mx-2 my-0 inline-flex align-center': isHeaderDesktopMenu,
            })}
          >
            <MenuItem
              item={item}
              hasFocus={hasFocus}
              onClick={onClick}
              useMegaNav={useMegaNav}
              isFooterMenuItem={isFooterMenu}
              isHeaderDesktopMenuItem={isHeaderDesktopMenu}
              isHeaderMobilePrimaryMenuItem={isHeaderMobilePrimaryMenu}
              isHeaderMobileSecondaryMenuItem={isHeaderMobileSecondaryMenu}
              isMegaNavMenuItem={isMegaNavMenu}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default Menu
